// FixedBottom.js

import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/CommonCtx';
import { Navigate } from 'react-router-dom';
//import { useTheme } from "@emotion/react";
import { styled } from '@mui/material/styles';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeIcon from '@mui/icons-material/Home';
import CameraIcon from '@mui/icons-material/Camera';
import CollectionsIcon from '@mui/icons-material/Collections';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Paper from '@mui/material/Paper';
//import Typography from '@mui/material/Typography';

function FixedBottom() {

    //const theme = useTheme();
    //const navigate = useNavigate();

    const disMenuList = [ 'MainMenu', 'LocMap', 'NotiBrd' ];

    const { user, ml, mode, setMode, setCamera } = useAuth();

    //const [value, setValue] = useState('0');
    const [value, setValue] = useState('');
    //const ref = useRef(null);

    //const [ seed, setSeed ] = useState(1);
    //const reset = () => {
    //    setSeed(Math.random());
    //};

    useEffect(() => {
    }, []);

    useEffect(() => {
        //ref.current.ownerDocument.body.scrollTop = 0;
    }, [ value ]);

    useEffect(() => {
        //console.log('mode', mode);
    }, [ mode ]);

    if (!user.lang){
        return <Navigate replace to='/signin' />; 
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);

        //if (newValue === ml.HOME) navigate('/');
        if (newValue === ml.HOME) {
            setMode('MainMenu');
            setCamera(0);
        } else if (newValue === ml.CAMERA) {
            let naction = 'action_' + Math.random();
            setCamera(naction);
        } else if (newValue === ml.GALLERY) {
            let naction = 'gallery_' + Math.random();
            setCamera(naction);
        } else if (newValue === ml.LOCATION) {
            setMode('LocMap');
            setCamera(0);
        }
    };
    
    const PaperBottom = styled(Paper)(({theme}) => ({
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0
    }));

    const BottomNavActionMenu = styled(BottomNavigationAction)(({theme}) => ({
        minWidth: 'auto',
        color: theme.palette.primary.light,
        '& .MuiBottomNavigationAction-label.Mui-selected': { 
            fontSize: '0.7rem'
        }
    }));

    //whitesmoke #f5f5f5

    return (
        <PaperBottom elevation={3} style={{ zIndex: 10 }}>
            {/* <BottomNavigation showLabels value={value} onChange={handleChange}> */}
            <BottomNavigation value={value} onChange={handleChange} sx={{ bgcolor: '#ffffff' }}>
                <BottomNavActionMenu label={ml.HOME} value={ml.HOME} icon={<HomeIcon color='inherit' />} />
                <BottomNavActionMenu label={ml.CAMERA} value={ml.CAMERA} icon={<CameraIcon color={disMenuList.includes(mode) ? 'disabled' : 'inherit'} />} disabled={disMenuList.includes(mode)} />
                <BottomNavActionMenu label={ml.GALLERY} value={ml.GALLERY} icon={<CollectionsIcon color={disMenuList.includes(mode) ? 'disabled' : 'inherit'} />} disabled={disMenuList.includes(mode)} />
                <BottomNavActionMenu label={ml.LOCATION} value={ml.LOCATION} icon={<LocationOnIcon color='inherit' />} />
            </BottomNavigation>
        </PaperBottom>
    );
};

export default FixedBottom;


